import { useEffect, useMemo, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useStoreOnboardingResponsesMutation } from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';

import { clear, getAllResponses } from 'store/modules/onboarding_responses';

export const useStoreOnboardingResponsesAfterSignIn = () => {
  const dispatch = useDispatch();
  const [storeOnboardingResponses] = useStoreOnboardingResponsesMutation();
  const graphaelDefaults = useGraphaelDefaults();
  const onboarding_responses = useSelector(getAllResponses);
  const responsesStored = useRef<boolean>(false);

  // We need to check all of these things in order to execute process
  // As `onboarding_responses` is used in both onboarding and post purchase flow
  // we dont want it to be trigger in the latter
  // most crucial check is checking for `contentTypes`
  // which does not exist in post purchase flow
  const isFinished = useMemo(
    () =>
      onboarding_responses.contentTypes.length > 0 &&
      onboarding_responses.scenarios.length > 0 &&
      onboarding_responses.tagIds.length > 0 &&
      onboarding_responses.storyMarkets.length > 0,
    [
      onboarding_responses.contentTypes.length,
      onboarding_responses.scenarios.length,
      onboarding_responses.storyMarkets.length,
      onboarding_responses.tagIds.length,
    ],
  );

  useEffect(() => {
    if (
      !responsesStored.current &&
      graphaelDefaults.context.headers.uid &&
      isFinished
    ) {
      (async () => {
        await storeOnboardingResponses({
          ...graphaelDefaults,
          variables: {
            serializedResponses: JSON.stringify(onboarding_responses),
          },
        });
        responsesStored.current = true;
        dispatch(clear());
      })();
    }
  }, [
    dispatch,
    graphaelDefaults,
    isFinished,
    onboarding_responses,
    storeOnboardingResponses,
  ]);
};
